import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

type ContainerProps = {
    isVertical?: boolean
    supported?: boolean
    highlighted?: boolean
    css?: FlattenSimpleInterpolation
}

export const StyledAxis = styled.div<ContainerProps>`
    position: relative;
    height: 100%;
    top: 0;
    cursor: pointer;

    &:hover::before {
        content: '';
        position: absolute;
        background: var(--gray-300);
    }

    ::after, ::before {
        ${({ isVertical }) =>
            isVertical
                ? css`
                      top: -1px;
                      left: -15px;
                      height: calc(100% + 2px);
                      width: calc(100% + 30px);
                  `
                : css`
                      top: -15px;
                      left: -1px;
                      height: calc(100% + 30px);
                      width: calc(100% + 2px);
                  `}
    }

    ${({ highlighted, supported, isVertical }) =>
        highlighted &&
        supported &&
        css`
            &::before {
                content: '';
                position: absolute;
                background: var(--beam-surface--primary);

                ${isVertical
                    ? css`
                          top: -1px;
                          left: -15px;
                          height: calc(100% + 1px);
                          width: calc(100% + 30px);
                      `
                    : css`
                          top: -15px;
                          left: -1px;
                          height: calc(100% + 30px);
                          width: calc(100% + 1px);
                      `}
            }
        `}

    

    ${({ supported }) =>
        !supported &&
        css`
            pointer-events: none;
        `}

    ${({ css }) => css}
`
